import React from 'react';

const ChartLegend = ({ items }) => (
  <div className="flex items-center justify-center gap-5 mt-3 mb-1">
    {items.map((item, i) => (
      <div key={i} className="flex items-center gap-2">
        <span
          className="inline-block rounded-full"
          style={{
            width: 8, height: 8, background: item.color,
            ...(item.dashed ? { border: `2px solid ${item.color}`, background: 'transparent' } : {}),
          }}
        />
        <span style={{ fontSize: '11px', color: '#525252', fontWeight: 500 }}>{item.name}</span>
      </div>
    ))}
  </div>
);

export default ChartLegend;
